import type { ThreadMessage } from "app/pages/sales-intelligence/modules/ai-agent/types/thread";

// A brief is always split into sections by h1–h3 markdown headings; API errors and empty responses have none.
const BRIEF_SECTION_HEADING_REGEX = /^#{1,3}[ \t]+\S/m;

export const isMeetingBrief = (content?: string): boolean => {
    const trimmedContent = content?.trim();

    if (!trimmedContent) {
        return false;
    }

    return BRIEF_SECTION_HEADING_REGEX.test(trimmedContent);
};

export const hasFailedMeetingBrief = (messages: readonly Pick<ThreadMessage, "type" | "content">[]): boolean => {
    const firstAiMessage = messages.find((message) => message.type === "ai");

    return !isMeetingBrief(firstAiMessage?.content);
};
